import { spacing } from '../../../theme';
import { maxWidth } from '../../../theme/variables/breakpoints';
import ProductSection from './product-section';
import PaymentSummary from './payment-summary';
import OrderInfoSection from './order-info-section';
import styled from 'styled-components';

export const OrderPriceSections = styled.div`
    display: grid;
    gap: 2rem;
    grid-template-columns: 60% auto;
    grid-template-rows: auto auto;
    align-items: start;
    gap: ${spacing.spacing6};
    @media ${maxWidth.small} {
        gap: ${spacing.spacing0};
        grid-template-columns: 1fr;
        grid-template-rows: auto auto auto;
    }
`;

export const OrderPriceArea = styled.div`
    display: flex;
    gap: 2rem;
    align-items: start;
    gap: ${spacing.spacing6};
    @media ${maxWidth.small} {
        gap: ${spacing.spacing0};
        grid-template-columns: 1fr;
        grid-template-rows: auto auto auto;
    }
`;

export const ProductArea = styled(ProductSection)`
    grid-column: 1;
    grid-row: 1;
    width: 100%;
    height: max-content;
    @media ${maxWidth.small} {
       width: 91.5%;
    }
`;

export const OrderInfoArea = styled(OrderInfoSection)`
    grid-column: 1;
    grid-row: 1;
    width: 100%;
    height: max-content;
    @media ${maxWidth.small} {
        width: 100%;
    }
`;

export const PaymentArea = styled(PaymentSummary)`
    grid-column: 2;
    grid-row: 1 / span 2;
    @media ${maxWidth.small} {
        grid-column: 1;
        grid-row: 2;
        width: 91.5%;
    }
`;
